import moment from 'moment';

export interface IExpirationItem {
    deviceId: string;
    vehicleName: string;
    itemName: string;
    expireDate: string;
    daysLeft: number;
}

export interface IExpirationGroups {
    expired: IExpirationItem[];
    days30: IExpirationItem[];
    days60: IExpirationItem[];
    days90: IExpirationItem[];
}

export const calculateDaysLeft = (dateString: string): number => {
    const today = moment().startOf('day');
    const expDate = moment(dateString, ['MM-DD-YYYY', 'YYYY-MM-DD']).startOf('day');

    if (!expDate.isValid()) return 999;

    return expDate.diff(today, 'days');
};

export const groupExpirations = (items: IExpirationItem[]): IExpirationGroups => {
    const groups: IExpirationGroups = {
        expired: [],
        days30: [],
        days60: [],
        days90: [],
    };

    items.forEach(item => {
        if (item.daysLeft < 0) {
            groups.expired.push(item);
        } else if (item.daysLeft >= 0 && item.daysLeft <= 30) {
            groups.days30.push(item);
        } else if (item.daysLeft > 30 && item.daysLeft <= 60) {
            groups.days60.push(item);
        } else if (item.daysLeft > 60 && item.daysLeft <= 90) {
            groups.days90.push(item);
        }
    });

    Object.values(groups).forEach(group => {
        group.sort((a, b) => a.daysLeft - b.daysLeft);
    });

    return groups;
};